import { QueryClient } from '@tanstack/react-query';
import Axios from 'axios';
import { ErrorCodes } from 'constants/error-codes';

const DEFAULT_RETRY_COUNT = 3;
const DEFAULT_STALETIME = 60000;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                if (Axios.isAxiosError(error)) {
                    const code = error.response?.status;
                    if (
                        code &&
                        (code >= ErrorCodes.RATE_LIMIT ||
                            code === ErrorCodes.UNAUTHORIZED ||
                            code === ErrorCodes.FORBIDDEN)
                    ) {
                        return false;
                    }
                }

                return failureCount < DEFAULT_RETRY_COUNT;
            },
            staleTime: DEFAULT_STALETIME,
        },
    },
});

export { queryClient };
